/**
 * 建立不受大小寫、符號或常見版本名稱影響的歌詞記憶鍵。
 * 只取第一位主要演出者，避免合作曲的演出者順序讓既有選擇失效。
 */
export function lyricChoiceKey(song) {
  const coreTitle = String(song?.title || "")
    .normalize("NFKC")
    .toLocaleLowerCase("zh-Hant")
    .replace(/\b(?:dj|remix|mix|live|cover|instrumental|sped\s*up|slowed)\b|dj版|現場版|现场版|伴奏|翻唱|加速|降速/giu, "")
    .replace(/[\s\p{P}\p{S}]+/gu, "");
  const primaryArtist = String(song?.artists?.[0] || "")
    .split(/\s*(?:&|\/|、|,|，|feat\.?|ft\.?|with|和)\s*/iu)[0]
    .normalize("NFKC")
    .toLocaleLowerCase("zh-Hant")
    .replace(/[\s\p{P}\p{S}]+/gu, "");
  return `${coreTitle}|${primaryArtist}`;
}

/** 將同步 LRC 與純文字歌詞整理成播放器可直接渲染的統一資料列。 */
export function parseLyricRows(lines = []) {
  const rows = [];
  for (const rawValue of lines) {
    const raw = String(rawValue || "").trim();
    if (!raw || /^\[(?:ti|ar|al|by|offset|re|ve):/iu.test(raw)) continue;
    const timestamps = [...raw.matchAll(/\[(\d{1,3}):(\d{2})(?:[.:](\d{1,3}))?\]/gu)];
    const lyricText = raw.replace(/\[(?:\d{1,3}):(?:\d{2})(?:[.:]\d{1,3})?\]/gu, "").trim();
    if (!lyricText) continue;
    if (!timestamps.length) {
      rows.push({ id: `plain-${rows.length}`, time: null, text: lyricText });
      continue;
    }
    for (const timestamp of timestamps) {
      const fraction = String(timestamp[3] || "0");
      const milliseconds = Number(fraction.padEnd(3, "0").slice(0, 3));
      rows.push({
        id: `${timestamp[1]}-${timestamp[2]}-${fraction}-${rows.length}`,
        time: Number(timestamp[1]) * 60 + Number(timestamp[2]) + milliseconds / 1000,
        text: lyricText,
      });
    }
  }
  return rows.sort((a, b) =>
    a.time === null || b.time === null ? 0 : a.time - b.time
  );
}
